export default {
  // Right-click menu options
  viewdetails: "Expand Details",
  noteNode: "Note Node",
  copyAddress: "Copy Address",
  newCanvas: "New Canvas",
  tagSettings: "Tag Settings",
  addTag: "Add Tag",
  modifyTag: "Modify Tag",
  deleteTag: "Delete Tag",
  joinSurvey: "Join Survey",
  ordinarySurvey: "Ordinary Survey",
  keySurvey: "Key Survey",
  joinMonitoring: "Join Monitoring",
  joinBoard: "Join Board",
  exchangeExpansion: "Exchange Expansion",
  aiModel: "AI Model:",
  firstFeeTraceability: "First Fee Traceability",
  multilayerTraceability: "Multilayer Traceability",
  transactionPathAnalysis: "Transaction Path Analysis",
  addToStart: "Add to Start",
  addToEnd: "Add to End",
  relatedFeeModel: "Related Fee Model",
  tornadoModel: "Tornado Model",
  deleteNode: "Delete Node",
  newOldStopModel: "New-Old Stop Model",
  singleChannelModel: "Single Channel Transfer Model",

  // Batch operations
  batchNote: "Batch Note",
  batchCopy: "Batch Copy",
  batchAddTag: "Batch Add Tag",
  batchJoinSurvey: "Batch Join Survey",
  batchJoinBoard: "Batch Join Board",
  directAssociation: "Direct Association",
  batchExpansion: "Batch Expansion",
  batchQueryBalance: "Batch Query Balance",
  commonTradingCounterpart: "Common Trading Counterpart",
  batchDeleteNode: "Batch Delete Node",
  // Shortcuts
  altV: "alt+v/⌥+v",
  ctrlC: "ctrl+C/⌘+C",
  altG: "alt+g/⌥+g",
  ctrlM: "ctrl+M/⌘+M",
  ctrlR: "ctrl+R/⌘+R",
  enter: "enter/return",

  // Error messages
  cannotSelectBothTypes: "Cannot select both survey nodes and normal nodes",
  aggregateNodeNotSupported: "Aggregate nodes do not support this operation!",
  notSupportMultipleTypes:
    "Does not support operating multiple types of nodes simultaneously",
  platformException: "Platform exception",
  tip: "Tip",
  noRelatedData:
    "Sorry, no related data found in the association query results",
  noMoreBranches:
    "No more branches or no results in this data source configuration",
  mixPlatformNodeNotSupported: "Mix platform node does not support this operation!",
  aggregationPointNotSupported: "Aggregation point does not support this operation!",
  // Save related
  saveInfo: "Save Info",
  modifyInfo: "Modify Info",

  // vis-network localization
  edit: "Edit",
  del: "Delete current node or relationship",
  back: "Back",
  addNode: "Add Node",
  addEdge: "Add Edge",
  editNode: "Edit Node",
  editEdge: "Edit Edge",
  addDescription: "Click on empty space to add node",
  edgeDescription: "Click and drag from a node to connect to another node",
  editEdgeDescription: "Drag edge to change relationship",
  createEdgeError: "Cannot connect edge to cluster",
  deleteClusterError: "Cannot delete cluster.",
  editClusterError: "Cannot edit cluster'",
};
